import React from 'react';
import './App.css';

import 'react-tabulator/lib/styles.css';
//import 'react-tabulator/lib/css/bootstrap/tabulator_bootstrap.css';
import 'react-tabulator/lib/css/tabulator_simple.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import { Button, ButtonGroup, Form, FormControl, InputGroup, ToggleButton, Toast } from 'react-bootstrap';
import { ReactTabulator } from "react-tabulator";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import RegionMap from "./region_selection_map_2024.jpg";
import ACADHelpFile from "./files/ACAD help file 2024.pdf";
import PEDHelpFile from "./files/PED help file.pdf";
import { faSearch } from '@fortawesome/free-solid-svg-icons'

import './custom/tabulator.css';

// const SOURCE_URL = "http://20.66.110.218:8000"
const SOURCE_URL = "https://api.bcr.eco/pif/2023"
// const SOURCE_URL = "http://localhost:8005/2023"

const COLUMNS: { [index: string]: any } = {
  "Population Estimate USA/ Canada": {visible:true, headerTooltip: "Population Estimate USA/Canada: Estimated breeding population in USA/Canada, a sum of BBS-based estimates, Ontario atlas-based estimates, and NWT checklist-based estimates (individuals, not pairs). Estimates have been rounded.", download:true,headerFilter: "minmax", headerFilterFunc: minMaxHeaderFilter,formatter: "money",    formatterParams: {      precision: 0,    },},
"Lower 95% bound USA/ Canada": {visible:true, headerTooltip: "Lower 95% bound USA/Canada: Lower 95% bound from 1,000 re-sampled population estimates for USA/Canada, rounded.", download:true,headerFilter: "minmax", headerFilterFunc: minMaxHeaderFilter,formatter: "money",    formatterParams: {      precision: 0,    },},
"Upper 95% bound USA/ Canada": {visible:true, headerTooltip: "Upper 95% bound USA/Canada: Upper 95% bound from 1,000 re-sampled population estimates for USA/Canada, rounded.", download:true,headerFilter: "minmax", headerFilterFunc: minMaxHeaderFilter,formatter: "money",    formatterParams: {      precision: 0,    },},
  "%pop-b": {visible:true, headerTooltip: "Percent of global population in region during breeding season", download:true, headerFilter: "minmax",    headerFilterFunc: minMaxHeaderFilter,    formatter: "money",    formatterParams: {      precision: 2,    },},
  "%pop-w": {visible:true, headerTooltip: "Percent of global pop in region during winter (stationary non-breeding season)", download:true, headerFilter: "minmax",    headerFilterFunc: minMaxHeaderFilter,    formatter: "money",    formatterParams: {      precision: 2,    },},
  "%use-m": {visible:true, headerTooltip: "maximum of percent of global pop's spring vs. fall migration period spent in this region", download:true, headerFilter: "minmax",    headerFilterFunc: minMaxHeaderFilter,    formatter: "money",    formatterParams: {      precision: 2,    },},
  "Sort": {visible:true, headerTooltip: "Sort order of American Ornithological Society checklist of North American Birds, 7th edition, 63rd supplement", download:true,},
"Common Name": {visible:true, headerTooltip: "English common name, according to   AOS checklist, 7th edition, 63rd supplement", download:true,headerFilter: true, multiselect: false,},
"Scientific Name": {visible:true, headerTooltip: "Scientific name, according to AOS checklist, 7th edition, 63rd supplement", download:true,headerFilter: true, multiselect: false,},
"Group": {visible:true, headerTooltip: "landbird, shorebird, waterbird, waterfowl", download:true,headerFilter: true, multiselect: true,},
"order": {visible:false, headerTooltip: "", download:true,},
"family": {visible:false, headerTooltip: "", download:true,},
"taxonomic notes": {visible:false, headerTooltip: "", download:true,},
"Canada": {visible:false, headerTooltip: "", download:true,filterType: "or",},
"USA": {visible:false, headerTooltip: "", download:true,filterType: "or",},
"Mexico": {visible:false, headerTooltip: "", download:true,filterType: "or",},
"C America": {visible:false, headerTooltip: "", download:true,filterType: "or",},
"Mig Status": {visible:false, headerTooltip: "", download:true,},
"Introduced": {visible:false, headerTooltip: "", download:true,},
"Nonbreeding only": {visible:false, headerTooltip: "", download:true,},
"PS-g": {visible:true, headerTooltip: "Population size global score", download:true,headerFilter: true, multiselect: true,},
"PS-g_s": {visible:false, headerTooltip: "", download:true,},
"PS-g_com": {visible:false, headerTooltip: "", download:true,},
"Global Pop Size": {visible:false, headerTooltip: "", download:true,},
"Global Pop Size#": {visible:true, headerTooltip: "Estimated global population size (# breeding-aged individuals)", download:true, headerFilter: "minmax",    headerFilterFunc: minMaxHeaderFilter,    formatter: "money",    formatterParams: {      precision: 0,    },},
"Pop Size_US-Ca": {visible:false, headerTooltip: "", download:true,},
"Pop Size_US-Ca#": {visible:false, headerTooltip: "", download:true,},
"PopYr": {visible:false, headerTooltip: "", download:true,},
"Pop Size_US-Ca_s": {visible:false, headerTooltip: "", download:true,},
"Pop Size_US-Ca_com": {visible:false, headerTooltip: "", download:true,},
"BD-g": {visible:true, headerTooltip: "Breeding Distribution global score", download:true,headerFilter: true, multiselect: true,},
"BD area": {visible:false, headerTooltip: "", download:true,},
"BD-g_s": {visible:false, headerTooltip: "", download:true,},
"BD-g_com": {visible:false, headerTooltip: "", download:true,},
"ND-g": {visible:true, headerTooltip: "Non-breeding Distribution global score", download:true,headerFilter: true, multiselect: true,},
"ND area": {visible:false, headerTooltip: "", download:true,},
"ND-g_s": {visible:false, headerTooltip: "", download:true,},
"ND-g_com": {visible:false, headerTooltip: "", download:true,},
"TB-c": {visible:true, headerTooltip: "Threats to Breeding continental score", download:true,headerFilter: true, multiselect: true,},
"TB-c_s": {visible:false, headerTooltip: "", download:true,},
"TB-c_com": {visible:false, headerTooltip: "", download:true,},
"CV-b": {visible:false, headerTooltip: "", download:true,},
"CV-b certainty": {visible:false, headerTooltip: "", download:true,},
"TN-c": {visible:true, headerTooltip: "Threats to Non-breeding continental score", download:true,headerFilter: true, multiselect: true,},
"TN-c_s": {visible:false, headerTooltip: "", download:true,},
"TN-c_com": {visible:false, headerTooltip: "", download:true,},
"CV-w": {visible:false, headerTooltip: "", download:true,},
"CV-w certainty": {visible:false, headerTooltip: "", download:true,},
"PT-c": {visible:true, headerTooltip: "Population Trend continental score", download:true,headerFilter: true, multiselect: true,},
"PT-c_s": {visible:false, headerTooltip: "", download:true,},
"PT-c_com": {visible:false, headerTooltip: "", download:true,},
"LT % change": {visible:false, headerTooltip: "", download:true,},
"LT trend (%/yr)": {visible:false, headerTooltip: "", download:true,},
"LT trend 90% lcl": {visible:false, headerTooltip: "", download:true,},
"LT trend 90% ucl": {visible:false, headerTooltip: "", download:true,},
"LT sig": {visible:false, headerTooltip: "", download:true,},
"ST % change": {visible:false, headerTooltip: "", download:true,},
"ST trend (%/yr)": {visible:false, headerTooltip: "", download:true,},
"ST trend 90% lcl": {visible:false, headerTooltip: "", download:true,},
"ST trend 90% ucl": {visible:false, headerTooltip: "", download:true,},
"ST sig": {visible:false, headerTooltip: "", download:true,},
"ST yrs": {visible:false, headerTooltip: "", download:true,},
"core/extended BBS": {visible:false, headerTooltip: "", download:true,},
"LT CI width": {visible:false, headerTooltip: "", download:true,},
"N": {visible:false, headerTooltip: "", download:true,},
"RA": {visible:false, headerTooltip: "", download:true,},
"NxRA": {visible:false, headerTooltip: "", download:true,},
"Half-Life": {visible:true, headerTooltip: "Estimated # of years until 50% of remaining population is lost, based on recent 10-yr BBS trend", download:true,headerFilter: "minmax", headerFilterFunc: minMaxHeaderFilter,},
"CCS-b": {visible:false, headerTooltip: "", download:true,},
"CCS-n": {visible:false, headerTooltip: "", download:true,},
"CCS-max": {visible:true, headerTooltip: "Continental Combined Score: the higher of CCS-b (Continental Combined Score--breeding season: PS-g + BD-g + TB-c + PT-c) or CCS-n (CCS non-breeding season: PS-g + ND-g + TN-c + PT-c)", download:true,headerFilter: "minmax", headerFilterFunc: minMaxHeaderFilter,},
"Continental Importance": {visible:true, headerTooltip: "(1) PIF Watch List/R2R Tipping Point Red, Orange, or Yellow categories to reflect differing degrees of urgency, (2) Watch List Yellow for species not on Tipping Point List, or (3) Common Bird in Steep Decline", download:true,headerFilter: true, multiselect: true,},
"IUCN Red List 2023": {visible:false, headerTooltip: "", download:true,},
"Urban": {visible:false, headerTooltip: "", download:true,},
"Agriculture": {visible:false, headerTooltip: "", download:true,},
"Breeding Biome": {visible:true, headerTooltip: "primary geographic regions in which species occurs during its breeding season", download:true,headerFilter: true, multiselect: true,},
"Nonbreeding Biome": {visible:true, headerTooltip: "primary geographic region in which species occurs during its stationary nonbreeding season (i.e., winter)", download:true,headerFilter: true, multiselect: true,},
"Primary Breeding Habitat": {visible:true, headerTooltip: "The broad habitat class which a species is most likely to occupy during its breeding season, followed by a more detailed description of its primary habitat", download:true,headerFilter: true, multiselect: true,},
"Secondary Breeding Habitat": {visible:false, headerTooltip: "", download:true,},
"Primary Nonbreeding Habitat": {visible:true, headerTooltip: "The broad habitat class a species is most likely to occupy during its stationary nonbreeding season (i.e., winter), followed by a more detailed description of its primary habitat", download:true,headerFilter: true, multiselect: true,},
"Secondary Nonbreeding Habitat": {visible:false, headerTooltip: "", download:true,},
"Region": {visible:true, headerTooltip: "Geographic scope of regional assessment. In Central America, countries. In Canada, USA, and USA/Mexico border, BCRs. See handbook for Mexican regions and asterisks.", download:true,headerFilter: true, multiselect: true,},
"BCR": {visible:true, headerTooltip: "Bird Conservation Region (see http://nabci-us.org/resources/bird-conservation-regions-map). See handbook where region has asterisk.", download:true,headerFilter: true, multiselect: true,},
"sort": {visible:true, headerTooltip: "", download:true,},
// "Common Name": {visible:true, headerTooltip: "English Common Name following the AOS 7th Edition Check-list, 63rd supplement (Chesser et al. 2022)", download:true,headerFilter: true, multiselect: false,},
// "Scientific Name": {visible:true, headerTooltip: "Scientific Name following the AOS 7th Edition Check-list, 63rd supplement (Chesser et al. 2022)", download:true,headerFilter: true, multiselect: false,},
"group": {visible:true, headerTooltip: "Type of bird (waterbird, waterfowl, shorebird, landbird)", download:true,headerFilter: true, multiselect: true,},
"mig status": {visible:false, headerTooltip: "", download:true,},
"breeds": {visible:false, headerTooltip: "", download:true,},
// "%pop-b": {visible:true, headerTooltip: "Percent of global population in region during breeding season", download:true, headerFilter: "minmax",    headerFilterFunc: minMaxHeaderFilter,    formatter: "money",    formatterParams: {      precision: 0,    },},
"AI-b": {visible:true, headerTooltip: "Area Importance score of the region during breeding season (including non-breeders present)", download:true,headerFilter: true, multiselect: true,},
"AI-b#": {visible:false, headerTooltip: "", download:true,},
"AI-b_s": {visible:false, headerTooltip: "", download:true,},
// "%pop-w": {visible:true, headerTooltip: "Percent of global pop in region during winter (stationary non-breeding season)", download:true, headerFilter: "minmax",    headerFilterFunc: minMaxHeaderFilter,    formatter: "money",    formatterParams: {      precision: 0,    },},
"AI-w": {visible:true, headerTooltip: "Area Importance score of the region during winter (stationary non-breeding season)", download:true,headerFilter: true, multiselect: true,},
"AI-w#": {visible:false, headerTooltip: "", download:true,},
"AI-w_s": {visible:false, headerTooltip: "", download:true,},
// "%use-m": {visible:true, headerTooltip: "maximum of percent of global pop's spring vs. fall migration period spent in this region", download:true, headerFilter: "minmax",    headerFilterFunc: minMaxHeaderFilter,    formatter: "money",    formatterParams: {      precision: 0,    },},
"AI-m": {visible:true, headerTooltip: "Area Importance score of the region based on the migration season (spring or fall) with highest migration through this region", download:true,headerFilter: true, multiselect: true,},
"AI-m_s": {visible:false, headerTooltip: "", download:true,},
"%use-s": {visible:false, headerTooltip: "", download:true,},
"AI-s": {visible:false, headerTooltip: "", download:true,},
"AI-s_s": {visible:false, headerTooltip: "", download:true,},
"%use-f": {visible:false, headerTooltip: "", download:true,},
"AI-f": {visible:false, headerTooltip: "", download:true,},
"AI-f_s": {visible:false, headerTooltip: "", download:true,},
"TB-r": {visible:true, headerTooltip: "Assessment score for regional threats--breeding", download:true,headerFilter: true, multiselect: true,},
"TB-r_s": {visible:false, headerTooltip: "", download:true,},
"TB-r_com": {visible:false, headerTooltip: "", download:true,},
"TN-r": {visible:true, headerTooltip: "Assessment score for regional threats--non-breeding", download:true,headerFilter: true, multiselect: true,},
"TN-r_s": {visible:false, headerTooltip: "", download:true,},
"TN-r_com": {visible:false, headerTooltip: "", download:true,},
"PT-r": {visible:true, headerTooltip: "Assessment score for regional population trend", download:true,headerFilter: true, multiselect: true,},
"PT-r_s": {visible:false, headerTooltip: "", download:true,},
"PT-r_com": {visible:false, headerTooltip: "", download:true,},
"trend source": {visible:false, headerTooltip: "", download:true,},
"ST years": {visible:false, headerTooltip: "", download:true,},
"core/extended": {visible:false, headerTooltip: "", download:true,},
"coverage": {visible:false, headerTooltip: "", download:true,},
"RCS-b": {visible:true, headerTooltip: "Regional Combined Score for breeding season", download:true, headerFilter: "minmax",    headerFilterFunc: minMaxHeaderFilter,    formatter: "money",    formatterParams: {      precision: 0,    },},
"RCS-w": {visible:true, headerTooltip: "Regional Combined Score for winter", download:true, headerFilter: "minmax",    headerFilterFunc: minMaxHeaderFilter,    formatter: "money",    formatterParams: {      precision: 0,    },},
"Regional Importance": {visible:true, headerTooltip: "Categories of Regional Importance the species qualifies for in the region", download:true,headerFilter: true, multiselect: true,},
"RI season": {visible:true, headerTooltip: "season(s) in which species qualifies for Regional Importance (b = breeding season, w = winter, m = migration)", download:true,headerFilter: true, multiselect: true,},
"CIR Watch List - season": {visible:false, headerTooltip: "", download:true,},
"CIR CBSD-c": {visible:false, headerTooltip: "", download:true,},
"CBSD-r": {visible:false, headerTooltip: "", download:true,},
"RC": {visible:false, headerTooltip: "", download:true,},
"RS": {visible:false, headerTooltip: "", download:true,},
"Action Code": {visible:true, headerTooltip: "The broad level of action recommended to address conservation needs. See handbook for codes.", download:true,headerFilter: true, multiselect: true,},
  
"Sequence AOS 60": {visible:true, headerTooltip: "Order of American Ornithological Society checklist of North American Birds, 7th edition, 60th supplement", download:true,},
"English Name": {visible:true, headerTooltip: "English common name, according to AOS checklist, 7th edition, 60th supplement", download:true,headerFilter: true, multiselect: false,},
// "Scientific Name": {visible:true, headerTooltip: "Scientific name, according to AOS checklist, 7th edition, 60th supplement", download:true,headerFilter: true, multiselect: false,},
// "Introduced": {visible:false, headerTooltip: "", download:true,},
"Population Estimate Global": {visible:true, headerTooltip: "Estimated global breeding population, based on extrapolating USA/Canada population to other parts of global range (individuals, not pairs). Estimates have been rounded.", download:true,headerFilter: "minmax", headerFilterFunc: minMaxHeaderFilter,formatter: "money",    formatterParams: {      precision: 0,    },},
"Source for Global Estimate": {visible:true, headerTooltip: "Source for Global Estimate: Sources of data used for Global Population Estimate, with sources listed in descending order by proportion of population estimate: 'bbs' = North American Breeding Bird Survey (2006-2015); 'nwt' = Northwest Territories & Nunavut Checklist survey data (1995-2001) combined with Breeding Bird Census data; 'ona' = Ontario 2nd Breeding Bird Atlas point counts (2001-2005); 'eBird' = eBird relative frequency data for June and 1st week of July (1970-2017) used to extrapolate to the Western Hemisphere south of USA; 'rng' = range map-based extrapolation to the Eastern Hemisphere; 'PIFSC' = estimated by Partners in Flight Science Committee. See other sources on Source Refs tab.", download:true,headerFilter: true, multiselect: false,},
// "Population Estimate USA/ Canada": {visible:true, headerTooltip: "Population Estimate USA/Canada: Estimated breeding population in USA/Canada, a sum of BBS-based estimates, Ontario atlas-based estimates, and NWT checklist-based estimates (individuals, not pairs). Estimates have been rounded.", download:true,headerFilter: "minmax", headerFilterFunc: minMaxHeaderFilter,},
// "Lower 95% bound USA/ Canada": {visible:true, headerTooltip: "Lower 95% bound USA/Canada: Lower 95% bound from 1,000 re-sampled population estimates for USA/Canada, rounded.", download:true,headerFilter: "minmax", headerFilterFunc: minMaxHeaderFilter,},
// "Upper 95% bound USA/ Canada": {visible:true, headerTooltip: "Upper 95% bound USA/Canada: Upper 95% bound from 1,000 re-sampled population estimates for USA/Canada, rounded.", download:true,headerFilter: "minmax", headerFilterFunc: minMaxHeaderFilter,},
"Source for USA/Canada Estimate": {visible:true, headerTooltip: "Source for USA/Canada Estimate: Sources of data used for USA/Canada Population Estimate, with sources listed in descending order by proportion of population estimates; see global sources description above and sources listed on the Source Refs tab.", download:true,headerFilter: true, multiselect: false,},
"Population Estimate BBS": {visible:false, headerTooltip: "", download:true,},
"Lower 95% bound BBS": {visible:false, headerTooltip: "", download:true,},
"Upper 95% bound BBS": {visible:false, headerTooltip: "", download:true,},
"Population Estimate Canada": {visible:true, headerTooltip: "Population Estimate Canada: Estimated breeding population in Canada, a sum of BBS-based estimates, Ontario atlas-based estimates, and NWT checklist-based estimates (individuals, not pairs). Estimates have been rounded.", download:true,headerFilter: "minmax", headerFilterFunc: minMaxHeaderFilter,formatter: "money",    formatterParams: {      precision: 0,    },},
"Lower 95% bound Canada": {visible:false, headerTooltip: "", download:true,},
"Upper 95% bound Canada": {visible:false, headerTooltip: "", download:true,},
"Population Estimate USA": {visible:true, headerTooltip: "Population Estimate USA: Estimated breeding population in USA, from BBS-based estimates (individuals, not pairs). Estimates have been rounded.", download:true,headerFilter: "minmax", headerFilterFunc: minMaxHeaderFilter,formatter: "money",    formatterParams: {      precision: 0,    },},
"Lower 95% bound USA": {visible:false, headerTooltip: "", download:true,},
"Upper 95% bound USA": {visible:false, headerTooltip: "", download:true,},
"Median Estimate USA/ Canada": {visible:false, headerTooltip: "", download:true,},
"Lower 80% bound USA/ Canada": {visible:false, headerTooltip: "", download:true,},
"Upper 80% bound USA/ Canada": {visible:false, headerTooltip: "", download:true,},
"Lower 80% bound BBS": {visible:false, headerTooltip: "", download:true,},
"Upper 80% bound BBS": {visible:false, headerTooltip: "", download:true,},
"Lower 80% bound Canada": {visible:false, headerTooltip: "", download:true,},
"Upper 80% bound Canada": {visible:false, headerTooltip: "", download:true,},
"Lower 80% bound USA": {visible:false, headerTooltip: "", download:true,},
"Upper 80% bound USA": {visible:false, headerTooltip: "", download:true,},
"% Global Estimate in USA/Canada": {visible:false, headerTooltip: "", download:true,},
"% Global Estimate in Western Hemisphere": {visible:false, headerTooltip: "", download:true,},
"BBS Routes": {visible:false, headerTooltip: "", download:true,},
"Species Routes": {visible:false, headerTooltip: "", download:true,},
"Detection Distance Category (m)": {visible:false, headerTooltip: "", download:true,},
"Pair Adjust Category": {visible:false, headerTooltip: "", download:true,},
"Time Adjust Mean": {visible:false, headerTooltip: "", download:true,},
"Time Adjust SD": {visible:false, headerTooltip: "", download:true,},
"Population Estimate USA/Canada (unrounded)": {visible:false, headerTooltip: "", download:true,},
"Lower 80% bound USA/Canada (unrounded)": {visible:false, headerTooltip: "", download:true,},
"Upper 80% bound USA/Canada (unrounded)": {visible:false, headerTooltip: "", download:true,},
"Lower 95% bound USA/Canada (unrounded)": {visible:false, headerTooltip: "", download:true,},
"Upper 95% bound USA/Canada (unrounded)": {visible:false, headerTooltip: "", download:true,},
"Population Estimate BBS (unrounded)": {visible:false, headerTooltip: "", download:true,},
"Population Estimate Canada (unrounded)": {visible:false, headerTooltip: "", download:true,},
"Population Estimate USA (unrounded)": {visible:false, headerTooltip: "", download:true,},
"Population Estimate": {visible:true, headerTooltip: "Estimated breeding population in the Region (individuals, not pairs). Estimates have been rounded.", download:true,headerFilter: "minmax", headerFilterFunc: minMaxHeaderFilter,formatter: "money",    formatterParams: {      precision: 0,    },},
"Lower 95% bound": {visible:true, headerTooltip: "Lower 95% bound from 1,000 re-sampled population estimates for the region, rounded.", download:true,headerFilter: "minmax", headerFilterFunc: minMaxHeaderFilter,formatter: "money",    formatterParams: {      precision: 0,    },},
"Upper 95% bound": {visible:true, headerTooltip: "Upper 95% bound from 1,000 re-sampled population estimates for the region, rounded.", download:true,headerFilter: "minmax", headerFilterFunc: minMaxHeaderFilter,formatter: "money",    formatterParams: {      precision: 0,    },},
"Data Source": {visible:true, headerTooltip: "Sources of data used to calculate Population Estimate: 'bbs' = North American Breeding Bird Survey (2006-2015); 'nwt' = Northwest Territories & Nunavut Checklist survey data (1995-2001) combined with Breeding Bird Census data; 'ona' = Ontario 2nd Breeding Bird Atlas point counts (2001-2005); 'rng' = range-based adjustments made when an estimate from one part of a region was extrapolated into another part that had no abundance data.", download:true,headerFilter: true, multiselect: true,},
"Estimated % of Global Population": {visible:true, headerTooltip: "Estimated % of Global Population: Estimated percent of global population that breeds in the region, based on relative abundance among regions (see data source below).", download:true,headerFilter: "minmax", headerFilterFunc: minMaxHeaderFilter, //formatter: (cell: any) => {const value = cell.getValue() as number; const multipliedValue = value * 100; return multipliedValue.toFixed(2) + '%';}
},
"Estimated % of USA/Canada Population": {visible:true, headerTooltip: "Estimated % of USA/Canada Population: Estimated percent of USA/Canada population that breeds in the region, based on relative abundance among regions (see data source below).", download:true,headerFilter: "minmax", headerFilterFunc: minMaxHeaderFilter, //formatter: (cell: any) => {const value = cell.getValue() as number; const multipliedValue = value * 100; return multipliedValue.toFixed(2) + '%';}
},
"Median Estimate": {visible:false, headerTooltip: "", download:true,},
"Lower 80% bound": {visible:false, headerTooltip: "", download:true,},
"Upper 80% bound": {visible:false, headerTooltip: "", download:true,},
"BBS Average (birds/rte)": {visible:false, headerTooltip: "", download:true,},
"Area of Region (km2)": {visible:false, headerTooltip: "", download:true,},
"Population Estimate (unrounded)": {visible:false, headerTooltip: "", download:true,},
"Lower 80% bound (unrounded)": {visible:false, headerTooltip: "", download:true,},
"Upper 80% bound (unrounded)": {visible:false, headerTooltip: "", download:true,},
"Lower 95% bound (unrounded)": {visible:false, headerTooltip: "", download:true,},
"Upper 95% bound (unrounded)": {visible:false, headerTooltip: "", download:true,},
"Province / State / Territory": {visible:true, headerTooltip: "", download:true,headerFilter: true, multiselect: true,},
"Country": {visible:true, headerTooltip: "", download:true,headerFilter: true, multiselect: true,},
"BCR Source": {visible:false, headerTooltip: "", download:true,},
"Jurisdiction Source": {visible:false, headerTooltip: "", download:true,},


}


function retitle(field: string) {
  if (field in COLUMNS && COLUMNS[field].hasOwnProperty("title")) {
    return COLUMNS[field].title;
  }
  field = field.replace(/_/g, " ");
  field = field.split(' ').map(function(word) {
    return word.replace(word[0], word[0].toUpperCase());
  }).join(' ');
  return field;
}

function untitle(field: string) {
  field = field.replace(/ /g, "_");
  field = field.toLowerCase();
  return field;
}

// function idify(field: string, filterType: string, value: string) {
//   return untitle(field) + "-" + unfiltertype(filterType) + "-" + untitle(value);
// }

function refiltertype(filterType: string) {
  switch (filterType) {
    case "!=":
      filterType = "≠";
      break;
    case "ne":
      filterType = "!=";
      break;
    case "eq":
      filterType = "=";
      break;
    case "gt":
      filterType = ">";
      break;
    case "lt":
      filterType = "<";
      break;
    case "in":
      filterType = "in";
      break;
  }
  return filterType;
}

function nullToEmptyString(value: any) {
  return value || "";
}

function removeSimilarFilters(filters: any, filterField: string, filterType: string) {
  let newFilters: any = [];
  for (const filter of filters) {
    if (Array.isArray(filter)) {
      newFilters.push(removeSimilarFilters(filter, filterField, filterType));
    } else {
      if (filter.hasOwnProperty("field") && filter.hasOwnProperty("type")) {
        if (!(filter.field === filterField && filter.type === filterType)) {
          newFilters.push(filter);
        }
      }
    }
  }
  return newFilters;
}

function minMaxHeaderFilter(headerValue: any, rowValue: any) {
  if (rowValue) {
    if (headerValue.start !== "") {
      if (headerValue.end !== "") {
        return rowValue >= headerValue.start && rowValue <= headerValue.end;
      } else {
        return rowValue >= headerValue.start;
      }
    } else {
      if (headerValue.end !== "") {
        return rowValue <= headerValue.end;
      }
    }
  }
  return headerValue.start === "" && headerValue.end === "";
}

function multiSelectHeaderFilter(headerValue: any, rowValue: any) {
  if (!rowValue) return false;
  if (headerValue.length === 0 || headerValue.includes(rowValue.toString())) {
    return true;
  }
}

function isImportant(data: any) {
  if (data.hasOwnProperty("Continental Importance")) {
    if (data["Continental Importance"] && data["Continental Importance"] != "Previously Watch List") {
      return true;
    }
  }

  if (data.hasOwnProperty("Regional Importance")) {
    if (data["Regional Importance"]) {
      return true;
    }
  }

  if (data.hasOwnProperty("Continental Importance in Region")) {
    if (data["Continental Importance in Region"]) {
      return true;
    }
  }
  return false;
}

const continental_importance_filter = {continental_importance: ""};
const continental_importance_in_region_filter = {continental_importance_in_region: "", regional_importance: 1};

class ImageMap {
  previousWidth: number = 2468;
  map: HTMLMapElement|null = null;
  image: HTMLImageElement|null = null;
  areas: HTMLCollectionOf<HTMLAreaElement>|null = null;
  length: number = 0;
  coordinates: any = [];

  constructor(map: HTMLMapElement | null, image: HTMLImageElement | null) {
    if (!(map && image)) return;
    let n: number = 0;
    this.areas = map.getElementsByTagName("area");
    this.length = this.areas.length;
    this.map = map;
    this.image = image;


    for (n = 0; n < this.length; n++) {
      this.coordinates[n] = this.areas[n].coords.split(",");
    }
    window.onresize = this.onResize;
  }

  public onResize() {
    if (!(this.map && this.image && this.areas)) return;
    let n: number = 0;
    let m: number = 0;
    let coordinateLength: number = 0;
    let x = this.image.offsetWidth / this.previousWidth;
    if (x === 0) return;
    for (n = 0; n < this.length; n++) {
      coordinateLength = this.coordinates[n].length;
      for (m = 0; m < coordinateLength; m++) {
        this.coordinates[n][m] *= x;
      }
      this.areas[n].coords = this.coordinates[n].join(",");
    }
    if (this.image.offsetWidth) {
      this.previousWidth = this.image.offsetWidth;
    }
    return true;
  };
}

type MyProps = {};
type MyState = {
  list: string,
  region: string,
  dataURL: string,
  filterType: string,
  filterField: string,
  lists: Array<any>,
  currentFields: Array<any>,
  currentFilters: Array<any>,
  currentSorters: Array<any>,
  acad_regions: Array<any>,
  ped_regions: Array<any>,
  speciesOfImportance: boolean;
  commonNames: boolean,
  versions: Array<any>,
  showCopied: boolean,
  searchFilter: string,
  imageMap: ImageMap|null,
};

class App extends React.Component<MyProps, MyState> {
  ref: any = null;

  constructor(props: any) {
    super(props);

    let list: string = "acad";
    let region: string = "global";
    let filters: any = [];
    let sorters: any = [];
    let speciesOfImportance: boolean = false;
    if (window.location.hash) {
      let hash = JSON.parse(window.atob(window.location.hash.substring(1)));
      list = hash.list;
      region = hash.region;
      filters = hash.filters;
      speciesOfImportance = hash.species_of_importance;

      // let noArrayFilters: any = [];
      // filters.forEach((filter: any) => {
      //   if (filter.type !== "in") {
      //     noArrayFilters.push(filter);
      //   }
      // });
      // filters = noArrayFilters;

      sorters = hash.sorters;
    }

    if (filters.length === 0) {
      this.setInitialFilters(list, region, []);
    } else {
      let noNullFilters = [];
      let orFilters: any = [];
      for (const filter of filters) {
        if (Array.isArray(filter)) {
          orFilters = orFilters.concat(filter);
        }
        if (filter.value) {
          if (filter.type === "in") {
            if (filter.value.length > 0) {
              noNullFilters.push(filter);
            }
          } else {
            noNullFilters.push(filter);
          }
        }
      }

      filters = noNullFilters;
      if (orFilters && orFilters.length) {
        console.log('Pushing OR Filters') //working here
        filters.push(orFilters);
      }
    }

    console.log("Initial state:");
    console.log(filters);

    this.state = {
      list: list,
      region: region,
      dataURL: SOURCE_URL + "/" + list + "/" + region + "?output_format=lines",
      lists: [
        {name: "ACAD", id: "acad"},
        {name: "PED", id: "ped"},
      ],
      acad_regions: [
        {name: "Global", id: "global"},
        {name: "Regional", id: "regional"},
      ],
      ped_regions: [
        {name: "Global", id: "global"},
        {name: "BCR", id: "bcr"},
        {name: "State/Province", id: "province"},
        {name: "BCR/Province", id: "bcr/province"},
      ],
      currentFields: [],
      currentFilters: filters,
      currentSorters: sorters,
      speciesOfImportance: speciesOfImportance,
      filterType: "=",
      filterField: "",
      commonNames: true,
      versions: [],
      showCopied: false,
      searchFilter: "",
      imageMap: null,
    };
  };

  setInitialFilters(list: string, region: string, filters: any) {
    if (filters.length === 0) {
      switch (list) {
        case "acad":
          switch (region) {
            case "global":
              filters.push({field: "USA", type: "=", value: "1"});
              filters.push({field: "Canada", type: "=", value: "1"});
              break;
            case "regional":
              //filters.push({field: "region", type: "in", value: ["BCR01"]});
              filters.push({field: "AI-b", type: "!=", value: null}); //working here
              filters.push({field: "AI-w", type: "!=", value: null});
              filters.push({field: "AI-m", type: "!=", value: null})
              break;
          }
          break;
        case "ped":
          switch (region) {
            case "bcr/province":
              //filters.push({field: "bcr", type: "in", value: ["1"]});
              break;
          }
      }

      this.setState({currentFilters: filters});
      console.log("Set Initial Filters:");
      console.log(filters);
    }
  }

  componentDidMount() {
    let versions = this.state.versions;

    fetch(SOURCE_URL + "/acad/global/version",{mode: "cors"})
        .then(r => r.json())
        .then(
          (result) => {
            versions.push(result);
            this.setState({versions: versions});
          },
          (error) => {
            console.log(error);
          }
        );

    fetch(SOURCE_URL + "/acad/regional/version")
        .then(r => r.json())
        .then(
            (result) => {
              versions.push(result);
              this.setState({versions: versions});
            },
            (error) => {
              console.log(error);
            }
        );

    fetch(SOURCE_URL + "/ped/global/version")
        .then(r => r.json())
        .then(
            (result) => {
              versions.push(result);
              this.setState({versions: versions});
            },
            (error) => {
              console.log(error);
            }
        );

    fetch(SOURCE_URL + "/ped/bcr/version")
        .then(r => r.json())
        .then(
            (result) => {
              versions.push(result);
              this.setState({versions: versions});
            },
            (error) => {
              console.log(error);
            }
        );

    fetch(SOURCE_URL + "/ped/province/version")
        .then(r => r.json())
        .then(
            (result) => {
              versions.push(result);
              this.setState({versions: versions});
            },
            (error) => {
              console.log(error);
            }
        );

    fetch(SOURCE_URL + "/ped/bcr/province/version")
        .then(r => r.json())
        .then(
            (result) => {
              versions.push(result);
              this.setState({versions: versions});
            },
            (error) => {
              console.log(error);
            }
        );

    let header: HTMLDivElement = document.getElementById("header-toolbar") as HTMLDivElement;
    if (header) {
      let height = header.clientHeight;
      let table: HTMLDivElement = document.getElementById("table-container") as HTMLDivElement;
      table.style.height = "calc(100vh - " + height.toString() + "px)";
    }

    let imageMap = new ImageMap(document.getElementById('image-map') as HTMLMapElement, document.getElementById("selection-map") as HTMLImageElement);
    imageMap.onResize();
    this.setState({imageMap: imageMap});
    return;

    // window.onresize = function(event: any) {
    //   // let header: HTMLDivElement = document.getElementById("header-toolbar") as HTMLDivElement;
    //   // if (header) {
    //   //   let height = header.clientHeight;
    //   //   console.log("Height: " + height.toString());
    //   //   let table: HTMLDivElement = document.getElementById("table-container") as HTMLDivElement;
    //   //   //table.style.height = "calc(100vh - " + height.toString() + "px)";
    //   // }
    // }
  }

  checkForFilter = (filterStruct: any, filterField: string): any => {
    if (!filterStruct) { return false; }
    if (Array.isArray(filterStruct)) {
      for (const filter of filterStruct) {
        let found = this.checkForFilter(filter, filterField);
        if (found) { return true; }
      }
    } else if (filterStruct.hasOwnProperty("field") && filterStruct.field === filterField) {
      return true;
    }
    return false;
  }

  checkIfFilterExists = (filterField: string) => {
    //if (!this.ref || !this.ref.table) { return false; }
    //let filters = this.ref.table.getFilters();
    let filters = this.state.currentFilters;

    return this.checkForFilter(filters, filterField);
  }

  getDownloadFilename = (filtered: Boolean) => {
    let filename: string = "";
    let version: string = "";

    this.state.versions.forEach(value => {
      if (this.state.list.toUpperCase() === value.list && this.state.region.toUpperCase() === value.region.toUpperCase()) {
        version = value.version;
      }
    });
    switch (this.state.list) {
      case "acad":
        filename += "ACAD ";
        break;
      case "ped":
        filename += "PopEsts ";
        break;
    }
    switch (this.state.region) {
      case "global":
        filename += "Global ";
        break;
      case "regional":
        filename += "Regional ";
        break;
      case "bcr":
        filename += "BCR ";
        break;
      case "bcr/province":
        filename += "BCR x ProvState ";
        break;
      case "province":
        filename += "ProvState ";
        break;
    }
    filename = filename + version;
    if (filtered) {
      filename += "-filtered.csv";
    } else {
      filename += ".xlsx";
    }
    return filename;
  }

  minMaxFilterEditor = (cell: any, onRendered: any, success: any, cancel: any) => {
    let end: any;
    let container = document.createElement("span");
    let start = document.createElement("input");
    start.setAttribute("type", "text");
    start.setAttribute("placeholder", "min");
    start.style.width = "50px";
    start.style.padding = "4px";
    start.style.boxSizing = "border-box";
    start.style.cursor = "default";
    start.style.outlineOffset = "-2px";
    start.style.borderWidth = "2px";

    start.value = cell.getValue();

    let column = cell.getColumn().getField();
    start.setAttribute("id", column + "-min");
    let filters = this.state.currentFilters;
    let app = this;

    function buildValues() {
      filters = removeSimilarFilters(filters, column, ">=");
      filters = removeSimilarFilters(filters, column, "<=");
      if (start.value) {
        filters.push({field: column, type: ">=", value: start.value});
      }
      if (end.value) {
        filters.push({field: column, type: "<=", value: end.value});
      }

      app.setState({currentFilters: filters});

      success({
        start: start.value,
        end: end.value,
      });
    }

    function keypress(e: any) {
      if( e.keyCode === 13) {
        buildValues();
      }

      if (e.keyCode === 27) {
        cancel();
      }
    }

    end = start.cloneNode();
    end.setAttribute("placeholder", "max");
    end.setAttribute("id", column + "-max");

    start.addEventListener("change", buildValues);
    //start.addEventListener("input", buildValues);
    start.addEventListener("blur", buildValues);
    start.addEventListener("keydown", keypress);
    end.addEventListener("change", buildValues);
    //end.addEventListener("input", buildValues);
    end.addEventListener("blur", buildValues);
    end.addEventListener("keydown", keypress);
    container.appendChild(start);
    container.appendChild(end);
    return container;
  }

  onColumnDefinitions = (definitions: any) => {
    let fields = this.state.currentFields;

    definitions.forEach((column: any) => {
      column.headerFilter = false;
      column.accessorDownload = nullToEmptyString;

      if (column.field in COLUMNS) {
        column.visible = COLUMNS[column.field].visible;

        if (COLUMNS[column.field].hasOwnProperty("headerFilter")) {
          switch (COLUMNS[column.field].headerFilter) {
            case "minmax":
              column.headerFilter = this.minMaxFilterEditor;
              break;
            case true:
              column.headerFilter = true;
              break;
          }
        }

        if (COLUMNS[column.field].hasOwnProperty("headerFilterFunc")) {
          column.headerFilterFunc = COLUMNS[column.field].headerFilterFunc;
          column.headerFilterLiveFilter = false;
        }

        if (COLUMNS[column.field].multiselect) {
          column.headerFilter = "select";

          let headerFilterValues: any = null;

          if (column.field === "bcr") {
            headerFilterValues = ["1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37"];
          } else {
            headerFilterValues = true;
          }

          column.headerFilterParams = {
            values: headerFilterValues,
            sortValuesList: "asc",
            multiselect: true,
          };
          column.headerFilterFunc = multiSelectHeaderFilter;
          column.headerFilterEmptyCheck = function (value: any) {
            return !value || value.length === 0;
          }
          //column.headerFilterFunc = "in";
        }

        if (COLUMNS[column.field].hasOwnProperty("title")) {
          column.title = COLUMNS[column.field].title;
        } else {
          column.title = retitle(column.title);
        }

        if (COLUMNS[column.field].hasOwnProperty("sorter")) {
          column.sorter = COLUMNS[column.field].sorter;
        }

        if (COLUMNS[column.field].hasOwnProperty("headerTooltip")) {
          column.headerTooltip = COLUMNS[column.field].headerTooltip;

          if (this.state.list === "acad" && this.state.region === "regional" && column.field === "region") {
            column.headerTooltip = "Select geographic region(s) for assessment.  See map for more details.";
          }
          if (this.state.list === "ped" && column.field === "bcr") {
            column.headerTooltip = "Select BCR(s)";
          }
        } else {
          column.headerTooltip = column.title;
        }

        if (COLUMNS[column.field].hasOwnProperty("formatter")) {
          column.formatter = COLUMNS[column.field].formatter;
        }

        if (COLUMNS[column.field].hasOwnProperty("formatterParams")) {
          column.formatterParams = COLUMNS[column.field].formatterParams;
        }

        if (COLUMNS[column.field].hasOwnProperty("download")) {
          column.download = COLUMNS[column.field].download;
        }

        if (column.visible) {
          let fieldObj = {"id": column.field, "name": column.title};
          if (!fields.includes(fieldObj))
          {
            fields.push(fieldObj);
          }
        }
      }
    });

    this.setState({currentFields: fields});

    return definitions;
  }

  onTableDataLoading = (data: any) => {
    data = data.map((row: any) => {
      if (row.hasOwnProperty("estimated_percent_of_global_population") && row.estimated_percent_of_global_population) {
        row.estimated_percent_of_global_population *= 100;
      }

      if (row.hasOwnProperty("estimated_percent_of_usa_canada_population" &&
          typeof(row.estimated_percent_of_usa_canada_population)) !== "undefined" &&
          row.estimated_percent_of_usa_canada_population !== null) {
        row.estimated_percent_of_usa_canada_population *= 100;
      }

      return row;
    });
    return data;
  }

  applyFilters = (filterStruct: any) => {
    console.log("applyFilters");
    let andFilters: any = [];
    let orFilters: any = [];
    if (Array.isArray(filterStruct)) {
      for (const filter of filterStruct) {
        let appliedFilters = this.applyFilters(filter);
        if (Array.isArray(appliedFilters)) {
          for (const appliedFilter of appliedFilters) {
            orFilters = orFilters.concat(appliedFilter);
          }
        } else {
          andFilters.push(appliedFilters[0]);
        }
      }
    } else {
      switch(true) {
        case COLUMNS[filterStruct.field].hasOwnProperty("headerFilter") && COLUMNS[filterStruct.field].headerFilter === "minmax":
          let start = document.getElementById(filterStruct.field + "-min") as HTMLInputElement;
          let end = document.getElementById(filterStruct.field + "-max") as HTMLInputElement;
          switch (filterStruct.type) {
            case ">=":
            case "<=":
              andFilters.push(filterStruct);
              break;
            case "minmax":
              this.ref.table.setHeaderFilterValue(filterStruct.field, filterStruct.value);
              break;
          }
          break;
        case COLUMNS[filterStruct.field].hasOwnProperty("multiselect"):
          //andFilters.push(filterStruct);
          if(filterStruct.value == null) //working here
            { 
              andFilters.push(filterStruct);
            }
          else{
            this.ref.table.setHeaderFilterValue(filterStruct.field, filterStruct.value);
          }
          
          break;
        case COLUMNS[filterStruct.field].hasOwnProperty("filterType") && COLUMNS[filterStruct.field].filterType === "or":
          orFilters.push(filterStruct);
          break;
        default:
          orFilters.push(filterStruct);
          break;
      }
    }

    if (orFilters.length > 0) {
      andFilters.push(orFilters);
    }

    console.log("Returning");
    console.log(andFilters);
    return andFilters;
  }

  redrawMinMaxHeaderFilters = () => {
    let headerFilters = this.ref.table.getHeaderFilters();
    for (const filter of headerFilters) {
      if (COLUMNS[filter.field].hasOwnProperty("headerFilter") && COLUMNS[filter.field].headerFilter === "minmax") {
        let start = document.getElementById(filter.field + "-min") as HTMLInputElement;
        let end = document.getElementById(filter.field + "-max") as HTMLInputElement;
        start.value = filter.value.start;
        end.value = filter.value.end;
      }
    }
  }

  onTableDataLoaded = () => {
    console.log("onTableDataLoaded");
    let filters = this.state.currentFilters;
    let andFilters = [];

    this.setInitialFilters(this.state.list, this.state.region, filters);

    console.log("Before apply:");
    console.log(filters);

    andFilters = this.applyFilters(filters);

    this.setState({currentFilters: andFilters});
    this.ref.table.setFilter(andFilters);
    this.onSetImportanceFilter(this.state.speciesOfImportance);

    this.redrawMinMaxHeaderFilters();

    console.log("Table filters set to:");
    console.log(andFilters);

    let sorters = [];
    for (const [key, value] of Object.entries(this.state.currentSorters)) {
      sorters.push({"column": key, "dir": value});
    }

    console.log("commonNames=")
    console.log(this.state.commonNames)
    if (this.state.commonNames) {
      this.ref.table.hideColumn("Scientific Name");
    } else {
      this.ref.table.hideColumn("Common Name");
    }

    if (sorters.length === 0) {
      sorters.push({"column": "region", "dir": "asc"});
      sorters.push({"column": "sort", "dir": "asc"});
    }
    this.ref.table.setSort(sorters);

      //REORDER COLUMNS HERE
    // this.ref.table.moveColumn("ps_g", "global_population_size_int", true);
    // this.ref.table.moveColumn("half_life", "breeding_biome");

    if (this.state.list === "acad" && this.state.region === "regional") {
      this.ref.table.hideColumn("bcr");
    }
  }

  onTableDataSorted = () => {

  }

  onTableDataFiltering = (filters: any) => {
    console.log("onTableDataFiltering");
    console.log(filters);
  }

  onTableDataFiltered = (filters: any) => {
    console.log("onTableDataFiltered");
    console.log(this.ref.table.getFilters(), this.ref.table.getHeaderFilters());
    let headerFilters = this.ref.table.getHeaderFilters();
    for (const filter of headerFilters) {
      if (typeof(filter.type) === "function") {
        if (typeof (COLUMNS[filter.field].headerFilter) === "string") {
          filter.type = "minmax";
          if (filter.value.start === "" && filter.value.end === "") {
            break;
          }
        } else {
          filter.type = "in";
        }
      }

      if (filter.value) {
        if ((Array.isArray(filter.value) && filter.value.length > 0) || !Array.isArray(filter.value)) {
          if (!this.checkIfFilterExists(filter.field)) {
            console.log("Adding " + filter.field + " to filters");
            filters.push(filter);
          }
        } else {
          console.log("Unsetting " + filter.field);
          let column = this.ref.table.getColumn(filter.field);
          column.setHeaderFilterValue("");
        }
      }
    }

    if (filters.length > 0) {
      this.setState({currentFilters: filters});
    }
  }

  onAddFilter = () => {

  }

  onClearFilters = () => {
    this.setState({currentFilters: [], filterField: "", speciesOfImportance: false});
    this.ref.table.clearFilter(true);
  }

  onRemoveFilter = (e: any) => {

  }

  setURL = () => {

  };

  onSetImportanceFilter = (addFilter: boolean) => {
    let filterFunction: any = null;
    if (addFilter) {
      if (this.state.region === "regional") {
        this.ref.table.addFilter(isImportant, continental_importance_in_region_filter);
      } else {
        this.ref.table.addFilter(isImportant, continental_importance_filter);
      }
    } else {
      if (this.state.region === "regional") {
        this.ref.table.removeFilter(isImportant, continental_importance_in_region_filter);
      } else {
        this.ref.table.removeFilter(isImportant, continental_importance_filter);
      }
    }
  }

  onCopyURL = () => {
    let currentURL = document.getElementById("current-url") as HTMLInputElement;
    let URLFilters = [];
    let currentFilters = this.ref.table.getFilters();

    let headerFilters = this.ref.table.getHeaderFilters();

    let i;
    for (i = 0; i < currentFilters.length; i++) {
      let filter = currentFilters[i];
      if (filter.value && filter.value.length > 0) {
        URLFilters.push(filter);
      }
      if (Array.isArray(filter) && filter.length > 0) {
        URLFilters.push(filter);
      }
    }

    for (i = 0; i < headerFilters.length; i++) {
      let filter = headerFilters[i];
      if (!this.checkForFilter(currentFilters, filter.field)) {
        if (typeof (filter.type) === "function") {
          if (typeof (COLUMNS[filter.field].headerFilter) === "string") {
            filter.type = "minmax";
          } else {
            filter.type = "in";
          }
        }
        if (filter.value) {
          if ((Array.isArray(filter.value) && filter.value.length > 0) || !Array.isArray(filter.value)) {
            URLFilters.push(filter);
          }
        }
      }
    }

    let sorterObjs = this.ref.table.getSorters();
    let sorters: any = {};

    sorterObjs.forEach(function(value: any) {
      sorters[value["field"]] = value["dir"];
    });

    let urlObj = {
      "list": this.state.list,
      "region": this.state.region,
      "filters": URLFilters,
      "sorters": sorters,
      "species_of_importance": this.state.speciesOfImportance,
    }
    let uri: string = window.location.href.split("#")[0];
    currentURL.value = uri + '#' + window.btoa(JSON.stringify(urlObj));

    currentURL.type = "text";
    currentURL.select();
    document.execCommand("copy");
    currentURL.type = "hidden";
    this.setState({showCopied: true});
  }

  onToggle = (e: any) => {
    const button = e.target;
    let value: string = button.value;

    if (value) {
      let filters: any = [];
      switch (value) {
        case "global":
        case "regional":
        case "bcr":
        case "state-province":
        case "bcr-province":
          this.onClearFilters();
          let region = value.toLowerCase();
          if (region === "state-province") {
            region = "province";
          }
          if (region === "bcr-province") {
            region = "bcr/province";
          }
          const newURL = SOURCE_URL + "/" + this.state.list + "/" + region + "?output_format=lines";
          this.setState({
            region: region,
            currentFilters: [],
            currentFields: [],
            speciesOfImportance: false,
          });
          this.setInitialFilters(this.state.list, region, []);

          this.ref.table.setData(newURL);
          break
        case "USA":
        case "Canada":
        case "Mexico":
        case "C America":
          let filterRegion = value;
          // if (filterRegion === "C America") { filterRegion = "central_america" }

          filters = this.state.currentFilters;

          console.log("Adding: " + filterRegion);
          console.log(this.checkIfFilterExists(filterRegion));
          if (this.checkIfFilterExists(filterRegion)) {
            filters = removeSimilarFilters(filters, filterRegion, "=");
          } else {
            let newFilter = {field: filterRegion, type: "=", value: "1"};
            let arrayFound = false;

            for (const filter of filters) {
              if (Array.isArray(filter)) {
                arrayFound = true;
                filter.push(newFilter);
              }
            }

            if (!arrayFound) {
              filters.push(newFilter);
            }
          }

          this.setState({currentFilters: filters});
          
          this.ref.table.setFilter(filters);
          console.log("Filters:");
          console.log(filters);

          break;
        case "common-names":
          this.setState({commonNames: true});
          this.ref.table.showColumn("Common Name");
          this.ref.table.hideColumn("Scientific Name");
          break;
        case "scientific-names":
          this.setState({commonNames: false});
          this.ref.table.showColumn("Scientific Name");
          this.ref.table.hideColumn("Common Name");
          break;
        case "all-species":
          this.setState({speciesOfImportance: false});
          this.onSetImportanceFilter(false);

          break;
        case "species-of-importance":
          this.setState({speciesOfImportance: true});
          this.onSetImportanceFilter(true);
          break;
        case "download-filtered":
          this.ref.table.download("csv", this.getDownloadFilename(true), {charset: "ANSI"}, "active");
          break;
        case "download-all":
          // this.ref.table.download("csv", this.getDownloadFilename(false), {}, "all");
          let downloadURL = SOURCE_URL + "/" + this.state.list + "/" + this.state.region + "/download";
          fetch(downloadURL)
              .then(response => response.blob())
              .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = this.getDownloadFilename(false);
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                console.log('Downloaded');
              })
              .catch(() => console.log('Download failed'));
          break;
        case "map":
          this.onShowModalImage();
          break;
        case "help":
          if (this.state.list === "acad") {
            window.open(ACADHelpFile, "_blank");
          } else if (this.state.list === "ped") {
            window.open(PEDHelpFile, "_blank");
          }
          break;
        default:
          console.log("Unhandled button: " + value);
          break;
      }
    }
  }

  onDropdown = (e: any) => {
    const value = e.target.textContent || e.target.innerText;

    switch (value) {
      case "=":
      case "<":
      case ">":
      case "≠":
      case "like":
        let filterType = value;
        if (value === "≠") {
          filterType = "!=";
        }

        this.setState({filterType: filterType});

        break;
      default:
        this.setState({filterField: untitle(value)});
        break;
    }
  }

  buildSearchFilter = (searchText: string) => {
    let columns = this.ref.table.getColumns();
    let filters = [];
    for (const column of columns) {
      if (column._column.visible) {
        filters.push({field: column.getField(), type: "like", value: searchText});
      }
    }

    this.ref.table.setFilter([filters]);
  }

  onSearch = (e: any) => {
    let searchElement: HTMLInputElement = document.getElementById("search-box") as HTMLInputElement;
    if (searchElement) {
      let searchText = searchElement.value;

      if (searchText.length > 0)
      {
        this.setState({searchFilter: searchText});
        this.buildSearchFilter(searchText);
      } else {
        this.ref.table.setFilter([]);
      }
    }
  }

  onAreaClick = (area: string) => {
    let headerFilters = this.ref.table.getHeaderFilters();
    let bcrFound: boolean = false;

    for (const filter of headerFilters) {
      if (filter.field === "region") {
        bcrFound = true;
        let oldValue: any = Array.from(filter.value);
        if (oldValue.includes(area)) {
          oldValue = oldValue.filter((item: string) => item !== area);
          oldValue = oldValue.filter((item: string) => item !== (area + "*"))
        } else {
          oldValue.push(area);
          switch (area) {
            case "BCR32":
            case "BCR33":
            case "BCR34":
            case "BCR35":
            case "BCR36":
            case "BCR37":
              oldValue.push(area + "*");
              break;
            default:
              break;
          }
        }
        this.ref.table.setHeaderFilterValue("region", oldValue);
      }
    }

    if (!bcrFound) {
      this.ref.table.setHeaderFilterValue("region", [area]);
    }

    this.onHideModalImage();
  }

  onShowModalImage = () => {
    let modalDiv = document.getElementById("map-selection");
    if (modalDiv) {
      modalDiv.style.display = "block";
      let imageMap = this.state.imageMap;
      if (imageMap) {
        imageMap.onResize();
      }
    }
  }

  onHideModalImage = () => {
    let modalDiv = document.getElementById("map-selection");
    if (modalDiv) {
      modalDiv.style.display = "none";
    }
  }

  render() {

    let filterTemplate = this.state.currentFields.map(v => (
        <button onClick={this.onDropdown}>{v.name}</button>
    ));

    // let allFiltersTemplate = this.state.currentFilters.map(v => (
    //     <div id={idify(v.field, v.type, v.value.toString())} className="filter-item" onClick={this.onRemoveFilter}>{retitle(v.field)} {v.type} {v.value}</div>
    // ));

    // noinspection JSUnusedGlobalSymbols
    const options = {
      height: "100%",
      //maxHeight: "calc(100vh - 50px)",
      layout: "fitDataFill",
      //layoutColumnsOnNewData: true,
      tooltipsHeader: true,
      autoColumns: true,
      autoResize: true,
      autoColumnsDefinitions: this.onColumnDefinitions,
      ajaxConfig: {
        headers: {
          "Content-Type": "application/json",
          "X-Token": "2345",
        }
      },
      ajaxURL: this.state.dataURL,
      ajaxResponse: function(url: any, params: any, response: any) {
        //console.log('ajaxResponse', url);
        return response;
      },
      ajaxError: function(error: any) {
        console.log('ajaxError', error)
        return error;
      },
      // https:/github.com/ngduc/react-tabulator/issues/76
      accessorDownload: (data: any) => data,
      downloadReady: (fileContents: any, blob: any) => blob,
      dataLoading: this.onTableDataLoading,
      dataLoaded: this.onTableDataLoaded,
      dataSorted: this.onTableDataSorted,
      dataFiltering: this.onTableDataFiltering,
      dataFiltered: this.onTableDataFiltered,
    }

    return (
        <div className="App">
          <div className="btn-toolbar" id="header-toolbar">

            {this.state.list === "acad" &&
              <ButtonGroup toggle className="mr-2 mb-2">
                <ToggleButton variant="outline-primary" onClick={this.onToggle} key="global" type="radio" name="list_scale" value="global" checked={this.state.region === "global"}>Global Scores</ToggleButton>
                <ToggleButton variant="outline-primary" onClick={this.onToggle} key="regional" type="radio" name="list_scale" value="regional" checked={this.state.region === "regional"}>Regional Scores</ToggleButton>
              </ButtonGroup>
            }
            {this.state.list === "ped" &&
              <ButtonGroup toggle className="mr-2 mb-2">
                <ToggleButton variant="outline-primary" onClick={this.onToggle} key="global" type="radio" name="list_scale" value="global" checked={this.state.region === "global"}>Continental/Global</ToggleButton>
                <ToggleButton variant="outline-primary" onClick={this.onToggle} key="bcr" type="radio" name="list_scale" value="bcr" checked={this.state.region === "bcr"}>BCR</ToggleButton>
                <ToggleButton variant="outline-primary" onClick={this.onToggle} key="state-province" type="radio" name="list_scale" value="state-province" checked={this.state.region === "province"}>State/Province</ToggleButton>
                <ToggleButton variant="outline-primary" onClick={this.onToggle} key="bcr-province" type="radio" name="list_scale" value="bcr-province" checked={this.state.region === "bcr/province"}>BCR x State/Province</ToggleButton>
              </ButtonGroup>
            }

            {this.state.list === "acad" ? this.state.region === "global" ?
              <ButtonGroup toggle className="mr-2 mb-2">
                <ToggleButton variant="outline-primary" onClick={this.onToggle} type="checkbox" key="Canada" name="display_region" value="Canada" checked={this.checkIfFilterExists("Canada")}>Canada</ToggleButton>
                <ToggleButton variant="outline-primary" onClick={this.onToggle} type="checkbox" key="USA" name="display_region" value="USA" checked={this.checkIfFilterExists("USA")}>USA</ToggleButton>
                <ToggleButton variant="outline-primary" onClick={this.onToggle} type="checkbox" key="Mexico" name="display_region" value="Mexico" checked={this.checkIfFilterExists("Mexico")}>Mexico</ToggleButton>
                <ToggleButton variant="outline-primary" onClick={this.onToggle} type="checkbox" key="C America" name="display_region" value="C America" checked={this.checkIfFilterExists("C America")}>Central America</ToggleButton>
              </ButtonGroup>
                :
                <ButtonGroup />
                :
                <ButtonGroup />
            }

            <ButtonGroup toggle className="mr-2 mb-2">
              <ToggleButton variant="outline-primary" onClick={this.onToggle} key="common-names" type="radio" name="names" value="common-names" checked={this.state.commonNames}>Common Names</ToggleButton>
              <ToggleButton variant="outline-primary" onClick={this.onToggle} key="scientific-names" type="radio" name="names" value="scientific-names" checked={!this.state.commonNames}>Scientific Names</ToggleButton>
            </ButtonGroup>

            {this.state.list === "acad" &&
              <ButtonGroup toggle className="mr-2 mb-2">
                <ToggleButton variant="outline-primary" onClick={this.onToggle} key="all-species" type="radio" name="species-of-importance"
                              value="all-species" checked={!this.state.speciesOfImportance}>All Species</ToggleButton>
                <ToggleButton variant="outline-primary" onClick={this.onToggle} key="species-of-importance" type="radio"
                              name="species-of-importance" value="species-of-importance"
                              checked={this.state.speciesOfImportance}>Species of Importance</ToggleButton>
              </ButtonGroup>
            }

            <ButtonGroup className="mr-2 mb-2">
              <input id="current-url" type="hidden" />
              <Button variant="success" onClick={this.onCopyURL} value="Copy URL">Copy URL</Button>
            </ButtonGroup>

            <ButtonGroup className="mr-2 mb-2">
              <Button variant="success" onClick={this.onClearFilters} value="clear-filters">Clear filters</Button>
            </ButtonGroup>

            <ButtonGroup className="mr-2 mb-2">
              <Button variant="secondary" onClick={this.onToggle} value="download-filtered">Download as filtered</Button>
              <Button variant="secondary" onClick={this.onToggle} value="download-all">Download all</Button>
            </ButtonGroup>

            {this.state.list === "acad" && this.state.region === "regional" &&
            <ButtonGroup className="mr-2 mb-2">
              <Button variant="success" onClick={this.onToggle} value="map">Map</Button>
            </ButtonGroup>
            }

            <ButtonGroup className="mr-2 mb-2">
              <Button variant="success" onClick={this.onToggle} value="help">Help</Button>
            </ButtonGroup>


            <InputGroup className="mr-2 mb-2">
              <FormControl type="text" onKeyUp={this.onSearch} placeholder="Search" aria-label="Search" id="search-box" />
              <InputGroup.Append><InputGroup.Text onClick={this.onSearch}><FontAwesomeIcon icon={faSearch} /></InputGroup.Text></InputGroup.Append>
            </InputGroup>
          </div>

          <div className="filter-interface">
            <div className="dropdown">
              <button id="filter-field-dropdown" className="dropdown-button" onClick={this.onToggle}>{this.state.filterField ? retitle(this.state.filterField) : "Field to Filter"} <span id="filter-field-arrow" className="caret right" /></button>
              <div className="dropdown-content" id="filter-field-dropdown-content">
                {filterTemplate}
              </div>
            </div>
            <div className="dropdown">
              <button id="filter-type-dropdown" className="dropdown-button" onClick={this.onToggle}>{refiltertype(this.state.filterType)} <span className="caret right" /></button>
              <div className="dropdown-content" id="filter-type-dropdown-content">
                <button onClick={this.onDropdown}>=</button>
                <button onClick={this.onDropdown}>&lt;</button>
                <button onClick={this.onDropdown}>&gt;</button>
                <button onClick={this.onDropdown}>≠</button>
                <button onClick={this.onDropdown}>like</button>
              </div>
            </div>
            <input id="filter-value" type="text" placeholder="value to filter on" />
            <button className="dropdown-button" onClick={this.onAddFilter}>Add filter</button>
            <button className="dropdown-button" onClick={this.onClearFilters}>Clear filters</button>
          </div>

          {/*<div className="display-filters">*/}
          {/*  {allFiltersTemplate}*/}
          {/*</div>*/}

          <div className="map-modal" id="map-selection">
            <span className="close" onClick={this.onHideModalImage}>&times;</span>
            <img src={RegionMap} id="selection-map" useMap="#image-map" className="map-modal-content "/>

            <map id="image-map" name="image-map">
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR01")} coords="446,299,448,227,295,312,10,412,8,454,245,584,282,436" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR02")} coords="269,560,452,554,394,495,365,395,402,373,492,345,540,366,544,345,496,303,489,240,592,259,662,314,616,342,540,382,505,373,485,421,531,469,544,558,555,635,481,654,361,628" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR03")} coords="590,253,601,181,773,209,963,393,1126,377,1209,246,1752,9,1826,15,1723,334,2035,532,2140,824,2092,874,2046,792,1989,813,1867,916,1822,877,1806,809,1543,864,1497,765,1399,752,1401,709,1287,700,1202,576,1128,565,1109,517,965,436,932,530,915,530,926,425,849,395,727,362" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR04")} coords="507,382,544,393,668,327,723,373,912,427,912,534,1021,604,1030,689,993,726,989,757,1026,757,1013,792,1015,901,880,848,834,717,788,724,786,661,699,554,642,550,559,595,524,447,494,419" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR05")} coords="577,598,664,558,727,606,773,654,790,731,827,724,910,929,895,979,971,1154,945,1180,949,1239,871,1441,819,1502" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR06")} coords="928,539,967,447,1091,517,1104,569,1189,582,1168,628,1185,724,1224,787,1242,848,1240,894,1229,920,1261,927,1272,986,1336,1031,1453,1055,1508,1204,1477,1191,1425,1160,1412,1175,1377,1147,1159,1040,1122,1132,1070,1021,1035,981,1024,794,1046,748,1015,737,1046,693,1030,589" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR07")} coords="1196,591,1181,619,1194,724,1248,864,1372,892,1577,1012,1697,1090,1734,1191,1885,1158,1922,1101,2096,1025,2131,1053,2290,979,2260,898,2151,840,2088,881,2044,811,1981,831,1970,866,1865,929,1545,877,1490,776,1396,761,1381,728,1268,707" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR08")} coords="1248,877,1242,912,1272,925,1279,981,1335,1023,1460,1049,1519,1193,1606,1217,1658,1260,1684,1245,1728,1252,1741,1269,1782,1269,1789,1250,1843,1252,1859,1241,1922,1256,1985,1184,2092,1204,2173,1119,2452,1136,2456,1045,2286,909,2299,977,2131,1055,2094,1034,1935,1103,1896,1164,1734,1195,1689,1090,1364,894" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR09")} coords="954,1099,1024,1095,1026,1191,1013,1199,1004,1223,1037,1232,1058,1306,1024,1330,1021,1295,991,1315,936,1326,943,1361,1019,1359,1054,1398,1093,1393,1085,1363,1098,1345,1161,1398,1126,1452,1115,1553,1048,1622,1008,1625,958,1572,934,1605,902,1461,882,1441,956,1236,982,1154" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR10")} coords="886,857,1009,907,1030,986,1102,1119,1120,1213,1142,1232,1155,1291,1187,1300,1189,1339,1218,1361,1253,1402,1242,1444,1270,1505,1220,1524,1135,1481,1163,1391,1104,1341,1080,1352,1076,1381,1056,1381,1030,1354,947,1350,943,1330,1009,1313,1039,1326,1063,1304,1052,1232,1026,1223,1026,1210,1041,1162,1035,1095,1011,1071,956,1086,908,1001,923,925" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR11")} coords="1161,1051,1407,1180,1427,1171,1503,1219,1495,1252,1523,1291,1510,1306,1525,1365,1564,1411,1577,1420,1580,1500,1558,1511,1538,1457,1499,1428,1497,1494,1477,1502,1433,1461,1442,1426,1412,1407,1418,1343,1370,1287,1322,1293,1270,1274,1253,1282,1224,1258,1165,1278,1126,1173" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR12")} coords="1521,1206,1660,1269,1769,1280,1795,1260,1852,1258,1926,1260,1987,1197,2088,1212,2024,1315,1972,1328,1979,1354,1891,1363,1837,1330,1795,1332,1817,1376,1808,1404,1750,1409,1702,1380,1628,1385,1558,1352,1540,1328,1534,1300,1514,1250" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR13")} coords="1808,1343,1863,1350,1891,1376,1979,1365,1987,1341,2066,1269,2055,1324,2055,1365,2040,1330,2018,1339,2009,1359,1994,1380,1994,1398,2016,1400,2044,1400,2053,1387,2061,1444,2048,1439,2044,1415,1992,1420,1985,1431,1948,1431,1859,1542,1850,1441" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR14")} coords="2127,1164,2066,1295,2061,1369,2046,1372,2035,1348,2005,1367,1998,1389,2046,1391,2068,1420,2098,1393,2098,1378,2175,1306,2234,1328,2327,1202,2303,1160,2269,1151,2181,1130" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR15")} coords="875,1446,873,1511,895,1583,912,1614,904,1644,921,1640,932,1620,897,1463" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR16")} coords="1050,1631,1122,1559,1130,1474,1144,1500,1220,1533,1255,1529,1277,1511,1266,1468,1283,1470,1290,1507,1287,1590,1281,1612,1281,1646,1296,1666,1266,1703,1285,1762,1268,1775,1235,1773,1215,1760,1207,1773,1196,1747,1163,1747,1113,1731,1091,1677,1048,1699,1028,1694,1048,1664" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR17")} coords="1174,1282,1218,1267,1248,1289,1272,1280,1320,1297,1362,1297,1405,1341,1401,1404,1423,1426,1423,1468,1375,1450,1294,1485,1290,1461,1263,1452,1261,1409,1253,1361,1239,1350,1211,1343,1196,1332,1202,1311" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR18")} coords="1294,1492,1362,1465,1344,1494,1390,1548,1368,1561,1386,1596,1375,1614,1396,1625,1390,1666,1370,1679,1394,1688,1390,1705,1381,1729,1359,1747,1375,1762,1370,1801,1357,1823,1370,1884,1303,1851,1272,1712,1307,1668,1292,1638" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR19")} coords="1355,1483,1372,1465,1431,1474,1468,1513,1495,1502,1484,1540,1499,1566,1486,1681,1473,1729,1457,1751,1457,1782,1416,1799,1423,1862,1375,1867,1364,1821,1381,1747,1407,1683,1405,1612,1396,1537" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR20")} coords="1383,1878,1436,1880,1438,1860,1468,1880,1460,1915,1427,1939,1372,1934,1375,1899,1431,1845,1425,1816,1462,1790,1464,1762,1492,1699,1508,1703,1523,1725,1497,1753,1551,1801,1525,1823,1510,1906,1464,1978,1447,1939,1479,1902,1481,1862,1423,1897" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR21")} coords="" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR22")} coords="1536,1710,1492,1681,1510,1562,1497,1524,1510,1450,1525,1455,1545,1507,1573,1518,1590,1500,1590,1413,1630,1481,1706,1474,1754,1492,1752,1520,1810,1474,1795,1505,1837,1507,1850,1496,1858,1540,1839,1586,1793,1572,1780,1581,1734,1553,1723,1601,1677,1627,1593,1598,1556,1668" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR23")} coords="1519,1311,1529,1302,1560,1361,1614,1383,1680,1391,1719,1393,1750,1413,1830,1407,1846,1489,1808,1494,1819,1461,1778,1485,1699,1468,1647,1468,1630,1465,1601,1391,1575,1398,1538,1374" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR24")} coords="1540,1721,1597,1607,1680,1635,1726,1612,1737,1568,1846,1596,1780,1747,1734,1745,1717,1666,1682,1657,1632,1718" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR25")} coords="1523,1734,1630,1723,1634,1797,1623,1830,1628,1858,1608,1908,1519,1919,1532,1834,1566,1799,1521,1758" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR26")} coords="1675,1668,1695,1670,1693,1703,1673,1740,1675,1790,1645,1871,1708,1910,1680,1936,1638,1926,1623,1891,1632,1830,1643,1777,1641,1729" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR27")} coords="1702,1670,1715,1677,1747,1784,1798,1814,1867,1801,1915,1755,1974,1694,2009,1625,2044,1638,2068,1668,2046,1699,2020,1725,1983,1764,1941,1838,1937,1880,1896,1912,1863,1899,1828,1919,1791,1897,1721,1910,1662,1869,1689,1788,1684,1751" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR28")} coords="1750,1758,1780,1753,1852,1596,1876,1526,1933,1465,1952,1444,2040,1426,2050,1459,2035,1481,1989,1513,1957,1601,1885,1701,1830,1751,1808,1766,1791,1793,1769,1788" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR29")} coords="1785,1799,1806,1788,1813,1771,1887,1714,1963,1607,1998,1520,2059,1476,2044,1507,2007,1553,1994,1588,1998,1616,1983,1677,1933,1718,1859,1793,1824,1808" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR30")} coords="2009,1609,2048,1620,2164,1417,2118,1376,2042,1520,2011,1559,2000,1592" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR31")} coords="1885,1928,1950,1884,2009,1997,2009,2061,1915,2087" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR32")} coords="816,1526,862,1461,871,1537,904,1609,897,1649,912,1653,899,1681,943,1703,960,1843,930,1812,915,1736,845,1699" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR33")} coords="910,1673,960,1590,1021,1635,1039,1668,1024,1707,1045,1723,1091,1779,1087,1810,1067,1823,1100,1923,1100,1980,1126,2021,1135,2067,1054,2113,936,1947,934,1843,969,1847,954,1699" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR34")} coords="1045,1712,1085,1690,1106,1731,1148,1751,1189,1760,1196,1779,1176,1795,1157,1790,1141,1832,1207,1908,1222,1960,1213,2000,1244,2054,1220,2045,1268,2109,1335,2189,1307,2183,1292,2211,1261,2211,1233,2150,1209,2122,1165,2037,1137,1917,1106,1880,1074,1834,1106,1803,1128,1773,1096,1760" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR35")} coords="1207,1777,1281,1777,1294,1851,1355,1891,1366,1934,1346,1963,1346,1980,1396,2056,1359,2080,1386,2107,1392,2152,1392,2196,1381,2207,1383,2224,1368,2222,1342,2185,1253,2076,1229,2011,1224,1926,1205,1891,1152,1836,1172,1799" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR36")} coords="1368,1945,1433,1947,1464,2004,1464,2137,1423,2135,1388,2076,1407,2067,1355,1982" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("BCR37")} coords="1473,2115,1481,2076,1479,2019,1588,1936,1673,1952,1732,1956,1728,1923,1708,1912,1652,1936,1623,1926,1621,1899,1590,1912,1505,1926,1468,1987,1468,2039,1466,2089" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("NEMH")} coords="1370,2085,1383,2078,1407,2141,1462,2144,1486,2019,1800,2026,1795,2056,1697,2072,1691,2102,1730,2131,1737,2174,1675,2168,1675,2244,1492,2233,1486,2159,1418,2150,1414,2224,1392,2220,1399,2161" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("NWPL")} coords="1096,1884,1133,1917,1152,2026,1233,2170,1250,2218,1215,2205,1152,2115,1035,2161,1024,2229,590,2237,585,2178,690,2067,989,2052,1032,2126,1146,2067,1109,1984" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("CEMH")} coords="1335,2198,1311,2192,1274,2220,1226,2216,1211,2235,1191,2253,1198,2274,1124,2294,1111,2261,721,2259,666,2327,666,2370,1106,2381,1124,2333,1255,2283,1263,2314,1294,2322,1305,2307,1283,2294,1292,2281,1346,2292,1399,2322,1471,2327,1481,2285,1425,2240,1381,2244" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("SCPL")} coords="579,2418,1078,2421,1100,2442,1274,2342,1324,2311,1290,2296,1296,2279,1344,2296,1375,2322,1436,2329,1451,2338,1429,2357,1394,2346,1340,2325,1100,2486,1087,2538,503,2534,505,2477" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("SEMH")} coords="1113,2495,1106,2536,1187,2719,1364,2724,1438,2540,1442,2501,1466,2414,1536,2416,1647,2447,1667,2379,1612,2362,1551,2383,1486,2335,1451,2338,1431,2359,1346,2329,1322,2344,1436,2392,1416,2486" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("MXCL")} coords="1791,2309,1819,2202,1776,2194,2214,2194,2234,2085,1776,2089,1747,2202,1695,2229,1686,2274,1569,2327,1519,2307,1477,2242,1460,2165,1425,2159,1433,2233,1464,2259,1488,2277,1490,2320,1545,2381,1638,2357,1673,2377,1671,2401,1702,2397,1686,2353,1747,2335" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("Belize")} coords="1754,2405,1778,2381,1800,2349,1843,2290,1983,2283,1985,2248,1839,2242,1822,2264,1789,2322,1774,2325,1752,2340" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("Guatemala")} coords="1656,2466,1665,2416,1710,2405,1697,2353,1743,2346,1752,2412,1778,2407,1754,2438,1754,2455,1721,2479,1710,2527,1471,2525,1475,2475" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("Honduras")} coords="1754,2453,1785,2403,1857,2382,1925,2312,2164,2307,2160,2355,1931,2364,1957,2401,1914,2427,1898,2425,1892,2445,1859,2456,1822,2493,1796,2467" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("Nicaragua")} coords="1817,2501,1961,2416,1976,2421,2000,2401,2003,2381,2251,2388,2251,2431,2016,2429,1968,2464,1976,2564,1887,2567" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("El Salvador")} coords="1728,2490,1750,2468,1802,2479,1806,2512,1761,2508,1743,2547,1854,2566,1863,2610,1584,2614,1582,2566,1699,2551" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("Costa Rica")} coords="1889,2573,1974,2573,2009,2597,2005,2654,1979,2656,1948,2641,1915,2689,1656,2687,1658,2645,1902,2643" shape="poly" />
              <area target="" alt="" title="" onClick={(e) => this.onAreaClick("Panama")} coords="2020,2597,2013,2650,2050,2687,2107,2671,2125,2663,2118,2643,2140,2608,2199,2658,2227,2632,2207,2588,2133,2575,2151,2547,2338,2547,2345,2499,2151,2490,2133,2514,2081,2599" shape="poly" />
            </map>
          </div>

          <div
            className="toasts"
            style={{
              position: 'absolute',
              top: 0,
              right: 0,
              zIndex: 1
            }}
          >
            <Toast onClose={() => this.setState({showCopied: false})} show={this.state.showCopied} delay={3000} autohide>
              <Toast.Header>
                <strong className="mr-auto">PIF</strong>
                <small>just now</small>
              </Toast.Header>
              <Toast.Body>Copied!</Toast.Body>
            </Toast>
          </div>
          <div id="table-container">
            <ReactTabulator
                ref={ref => (this.ref = ref)}
                data={[]}
                columns={[]}
                tooltips={true}
                options={options}
            />
          </div>
        </div>
    );
  }
}

export default App;
